import { useState, useEffect } from 'react';
import { MaintenanceLogsView } from './MaintenanceLogsView';
import { CreateMaintenanceLogPage } from './CreateMaintenanceLogPage';
import { EditMaintenanceLogPage } from './EditMaintenanceLogPage';
import { MaintenanceLogDetailPage } from './MaintenanceLogDetailPage';

export function MaintenanceView() {
  const [logView, setLogView] = useState<'list' | 'create' | 'edit' | 'detail'>('list');
  const [selectedLogId, setSelectedLogId] = useState<string | null>(null);

  // Check URL for log ID on mount and when URL changes
  useEffect(() => {
    const handleUrlChange = () => {
      const path = window.location.pathname;
      
      // Check for specific log ID
      const match = path.match(/\/maintenance\/([a-f0-9-]+)$/);
      if (match) {
        const logId = match[1];
        setSelectedLogId(logId);
        setLogView('detail');
      } else if (path.includes('/maintenance/create')) {
        setLogView('create');
      } else if (path === '/maintenance') {
        // Reset to list view when navigating to /maintenance
        setLogView('list');
        setSelectedLogId(null);
      }
    };

    // Check on mount
    handleUrlChange();

    // Listen for popstate (back/forward buttons)
    window.addEventListener('popstate', handleUrlChange);
    
    // Listen for custom urlchange event (when sidebar navigation changes URL)
    window.addEventListener('urlchange', handleUrlChange);
    
    return () => {
      window.removeEventListener('popstate', handleUrlChange);
      window.removeEventListener('urlchange', handleUrlChange);
    };
  }, []);


  // Maintenance Logs handlers
  const handleCreateLog = () => {
    window.history.pushState({}, '', '/maintenance/create');
    setLogView('create');
  };
  const handleViewLogDetails = (logId: string) => {
    window.history.pushState({}, '', `/maintenance/${logId}`);
    setSelectedLogId(logId);
    setLogView('detail');
  };
  const handleEditLog = (logId: string) => {
    window.history.pushState({}, '', `/maintenance/${logId}/edit`);
    setSelectedLogId(logId);
    setLogView('edit');
  };
  const handleBackToList = () => {
    window.history.pushState({}, '', '/maintenance');
    setLogView('list');
    setSelectedLogId(null);
  };
  const handleLogCreated = (logId: string) => {
    window.history.pushState({}, '', `/maintenance/${logId}`);
    setSelectedLogId(logId);
    setLogView('detail');
  };
  const handleLogUpdated = () => {
    if (selectedLogId) {
      window.history.pushState({}, '', `/maintenance/${selectedLogId}`);
      setLogView('detail');
    }
  };

  // Render maintenance logs views
  if (logView === 'create') {
    return <CreateMaintenanceLogPage onBack={handleBackToList} onSuccess={handleLogCreated} />;
  }
  if (logView === 'edit' && selectedLogId) {
    return <EditMaintenanceLogPage logId={selectedLogId} onBack={handleBackToList} onSuccess={handleLogUpdated} />;
  }
  if (logView === 'detail' && selectedLogId) {
    return (
      <MaintenanceLogDetailPage
        logId={selectedLogId}
        onBack={handleBackToList}
        onEdit={() => handleEditLog(selectedLogId)}
      />
    );
  }
  
  return (
    <MaintenanceLogsView
      onCreateNew={handleCreateLog}
      onViewDetails={handleViewLogDetails}
      onEdit={handleEditLog}
    />
  );
}
